export default __webpack_public_path__ + "static/media/ReviewScreenshot.ad4b9365.png";